var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Data } from "./data";
import { OrderItem } from "./order-item";
var Condition = /** @class */ (function (_super) {
    __extends(Condition, _super);
    function Condition() {
        var _this = _super.call(this) || this;
        _this.class = "Condition";
        _this.applicable = 1; //# times of meeting the condition
        _this.discounted = false; //used for amount condition
        _this.count = 1; // itemgroup count
        return _this;
    }
    /**Clone original condition as a new condition object**/
    Condition.cloneCondition = function (cond) {
        var c = new Condition();
        if (cond.type)
            c.type = cond.type;
        if (cond.code)
            c.code = cond.code;
        if (cond.member)
            c.member = cond.member;
        if (cond.amount)
            c.amount = cond.amount;
        if (cond.applicable)
            c.applicable = cond.applicable;
        if (cond.discounted)
            c.discounted = cond.discounted;
        if (cond.applyHandling)
            c.applyHandling = cond.applyHandling;
        if (cond.display)
            c.display = cond.display;
        if (cond.prefix)
            c.prefix = cond.prefix;
        if (cond.level)
            c.level = cond.level;
        if (cond.tiers)
            c.tiers = cond.tiers.slice();
        if (cond.source)
            c.source = cond.source;
        if (cond.couponPoint)
            c.couponPoint = cond.couponPoint;
        if (cond.count)
            c.count = cond.count;
        if (cond.traverseItemsDiscountable)
            c.traverseItemsDiscountable = cond.traverseItemsDiscountable;
        if (cond.ignoreCase)
            c.ignoreCase = cond.ignoreCase;
        c.getLevel();
        c.getDisplay();
        return c;
    };
    /**
     * applying discount and get discount amount
     * @param order: current order
     * @param promo: discount
     * @param benefit: discount's benefit
     * **/
    Condition.prototype.apply = function (order, promo, benefit, store, roundPrecision) {
        var _this = this;
        if (roundPrecision === void 0) { roundPrecision = 1; }
        if (this.getLevel() == 'item') {
            var total_1 = 0;
            if (this.type == "itemgroup_count" || this.type == 'item_count') {
                if (benefit.max > 1) {
                    var benefitMax_1 = benefit.max;
                    //sort order item with price to set discount to the min value orderitem
                    order.orderitems.sort(function (a, b) { return a.total - b.total; });
                    var ois = [];
                    ois = JSON.parse(JSON.stringify(order.orderitems));
                    // find the oi which has the condition code
                    ois = ois.filter(function (oi) {
                        return _this.oiContainsCode(oi);
                    });
                    var totalCount = ois.reduce(function (a, b) { return a + b.quantity; }, 0);
                    this.applicable = Math.floor(totalCount / this.count);
                    //set orderitems from min to max
                    // ois = ois.sort((a, b) =>a.total - b.total);
                    var count_1 = 0;
                    order.orderitems.forEach(function (oi) {
                        if (_this.oiContainsCode(oi) && count_1 < _this.applicable) {
                            var applyCount = void 0;
                            var discount = void 0;
                            if (((oi.quantity - oi['discountClaimed']) > 0)) {
                                if ((oi.quantity - oi['discountClaimed']) >= benefitMax_1) {
                                    count_1 = benefit.max;
                                    discount = benefit.apply(order, _this, promo, oi, benefitMax_1, store, roundPrecision);
                                    oi['discountClaimed'] += benefitMax_1;
                                    benefitMax_1 = 0;
                                }
                                else {
                                    applyCount = (_this.applicable - count_1) < oi.quantity ? (_this.applicable - count_1) : oi.quantity;
                                    discount = benefit.apply(order, _this, promo, oi, applyCount, store, roundPrecision);
                                    oi['discountClaimed'] += applyCount;
                                    benefitMax_1 = benefitMax_1 - oi.quantity;
                                }
                            }
                            count_1 += applyCount;
                            //let discount = benefit.apply(order, this, promo, oi, 0, store, orderManager);
                            total_1 += discount;
                            if (discount || benefit.applied) {
                                if (promo.backendId)
                                    oi.discountCode = promo.backendId;
                                oi.discountDesc = promo.desc ? promo.desc : promo.name;
                            }
                        }
                    });
                }
                else if (benefit.max == 1) {
                    var minOi = void 0;
                    var minTotal = void 0;
                    for (var _i = 0, _a = order.orderitems; _i < _a.length; _i++) {
                        var oi = _a[_i];
                        if (this.oiContainsCode(oi) && !this.hasExistingItemLevelDiscount(oi, promo)) {
                            if ((!minTotal || minTotal > oi.total) && (oi['discountClaimed'] < oi.quantity)) {
                                minTotal = oi.total;
                                minOi = oi;
                            }
                        }
                    }
                    if (minOi) {
                        minOi['discountClaimed']++;
                    }
                    if (minOi) {
                        var discount = benefit.apply(order, this, promo, minOi, 1, store, roundPrecision);
                        total_1 += discount;
                        if (discount || benefit.applied) {
                            if (promo.backendId)
                                minOi.discountCode = promo.backendId;
                            minOi.discountDesc = promo.desc ? promo.desc : promo.name;
                        }
                    }
                }
            }
            else {
                var benefitMax = benefit.max;
                order.orderitems.forEach(function (oi) {
                    if (_this.oiContainsCode(oi) && !_this.hasExistingItemLevelDiscount(oi, promo)) {
                        var discount = 0;
                        if (((oi.quantity - oi['discountClaimed']) > 0) && benefitMax > 0) {
                            if ((oi.quantity - oi['discountClaimed']) >= benefitMax) {
                                discount = benefit.apply(order, _this, promo, oi, benefitMax, store, roundPrecision);
                                oi['discountClaimed'] += benefitMax;
                                benefitMax = 0;
                            }
                            else {
                                discount = benefit.apply(order, _this, promo, oi, oi.quantity, store, roundPrecision);
                                oi['discountClaimed'] += oi.quantity;
                                benefitMax = benefitMax - oi.quantity;
                            }
                        }
                        total_1 += discount;
                        // oi.discounts.push(promo); //no use
                        if (discount || benefit.applied) {
                            if (promo.backendId)
                                oi.discountCode = promo.backendId;
                            oi.discountDesc = promo.desc ? promo.desc : promo.name;
                        }
                    }
                });
            }
            return total_1;
        }
        else {
            return benefit.apply(order, this, promo, null, 0, store, roundPrecision);
        }
    };
    /**check conditions to use the discount**/
    Condition.prototype.isSatisfied = function (order, promo) {
        var _this = this;
        var ok = false;
        if (!promo) {
            console.log("isSatisfied: ", ok);
            return ok;
        }
        switch (this.type.toLowerCase()) {
            //unconditional
            case 'all': {
                ok = true;
                break;
            }
            case 'coupon': {
                ok = true;
                break;
            }
            case 'guest': {
                this.applicable = 0;
                if (!this.member && !order.member) {
                    ok = true;
                    this.applicable = 1;
                }
                break;
            }
            //check member type, check member tier
            case 'member': {
                this.applicable = 0;
                if (this.member && order.member && order.member.method != 'device') {
                    if (this.tiers) {
                        if (!order.member.tier || this.tiers.indexOf(order.member.tier) < 0) {
                            ok = false;
                            break;
                        }
                    }
                    this.applicable = 1;
                    ok = true;
                }
                break;
            }
            //TODO: maintotal???
            case 'total':
            case 'maintotal': {
                if (this.amount) {
                    var total_2 = this.discounted ? order.grandTotal : order.total;
                    if (this.discounted) {
                        // if promotion applied before, remove it and recalculate again
                        var existing = order.promotions.find(function (promotion) { return promotion.id === promo.id; });
                        if (existing) {
                            total_2 += existing.amount;
                        }
                    }
                    total_2 = this.applyHandling ? total_2 + order.handling : total_2;
                    //unlock benefit special deal
                    if (!this.discounted && promo.benefits && promo.benefits[0] && promo.benefits[0].type == "unlock") {
                        if (promo.benefits[0].code) {
                            var code_1 = promo.benefits[0].code;
                            order.orderitems.forEach(function (oi) {
                                if (oi.categoryId == code_1 && oi.quantity > 0) {
                                    total_2 -= oi.total * oi.quantity;
                                }
                            });
                        }
                    }
                    if (total_2 >= this.amount) {
                        this.applicable = Math.floor(total_2 / this.amount);
                        ok = true;
                    }
                    else {
                        this.applicable = 0;
                    }
                }
                break;
            }
            //ordered mainitem(s)
            case 'item': {
                if (this.code) {
                    this.applicable = 0;
                    if (this.code.toLowerCase() == "all") {
                        ok = true;
                        order.orderitems.forEach(function (oi) {
                            _this.applicable += oi.quantity;
                        });
                        break;
                    }
                    var codes = this.code.split(",");
                    var total = 0;
                    var minTotal = 0;
                    if (codes && codes.length > 0) {
                        for (var _i = 0, _a = order.orderitems; _i < _a.length; _i++) {
                            var oi = _a[_i];
                            var item = oi.items[0]; //Main Item
                            if (codes.indexOf(item.id) >= 0) {
                                if (!this.hasExistingItemLevelDiscount(oi, promo)) {
                                    total += oi.quantity;
                                    oi['tmpApplied'] = 0;
                                    if (oi['tmpApplied'] < oi.quantity && !(minTotal >= this.count)) {
                                        var q = oi.quantity;
                                        if ((q - oi['tmpApplied']) > 0) {
                                            if (q < this.count) {
                                                oi['tmpApplied'] += q;
                                                minTotal += q;
                                            }
                                            else {
                                                oi['tmpApplied'] += this.count;
                                                minTotal += this.count;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        ok = (total >= this.count && minTotal >= this.count);
                        this.applicable = Math.floor(total / this.count);
                    }
                }
                break;
            }
            //ordered items as Mainitem within specific itemgroup(s)
            case 'mainitem_count': {
                if (this.code) {
                    this.applicable = 0;
                    if (this.code.toLowerCase() == "all") {
                        ok = true;
                        order.orderitems.forEach(function (oi) {
                            var item = oi.items[0]; //Main Item
                            var qty = oi.quantity * item.quantity;
                            _this.applicable += qty;
                        });
                    }
                    else {
                        var codes = this.code.split(",");
                        if (codes && codes.length > 0) {
                            for (var _b = 0, _c = order.orderitems; _b < _c.length; _b++) {
                                var oi = _c[_b];
                                var item = oi.items[0]; //Main Item
                                if (codes.indexOf(item.id) >= 0) {
                                    //if (!this.hasExistingItemLevelDiscount(oi, promo)) {
                                    this.applicable += oi.quantity * item.quantity;
                                    //}
                                }
                            }
                        }
                    }
                    ok = this.applicable >= this.count;
                }
                break;
            }
            case 'itemgroup': {
                if (this.code) {
                    this.applicable = 0;
                    if (this.code.toLowerCase() == "all") {
                        ok = true;
                        order.orderitems.forEach(function (oi) {
                            _this.applicable += oi.quantity;
                        });
                        break;
                    }
                    var codes = this.code.split(",");
                    if (codes && codes.length > 0) {
                        for (var _d = 0, _e = order.orderitems; _d < _e.length; _d++) {
                            var oi = _e[_d];
                            if (oi.groups && oi.groups.length > 0) {
                                var group = oi.groups[0]; //Main itemgroup
                                if (codes.indexOf(group.id) >= 0) {
                                    if (!this.hasExistingItemLevelDiscount(oi, promo)) {
                                        this.applicable += oi.quantity;
                                    }
                                }
                            }
                        }
                    }
                    ok = this.applicable > 0;
                }
                break;
            }
            //Purchase X in specific one item group (X > 0)
            case "itemgroup_count": {
                //reset
                this.applicable = 0;
                if (this.code && this.count) {
                    if (this.code.toLowerCase() == "all") {
                        ok = true;
                        order.orderitems.forEach(function (oi) {
                            _this.applicable += oi.quantity;
                        });
                        break;
                    }
                    var codes = this.code.split(",");
                    var total = 0;
                    var minTotal = 0;
                    var minOi = void 0;
                    if (codes && codes.length > 0) {
                        for (var _f = 0, _g = order.orderitems; _f < _g.length; _f++) {
                            var oi = _g[_f];
                            if (oi.groups && oi.groups.length > 0) {
                                var group = oi.groups[0]; //Main itemgroup
                                if (codes.indexOf(group.id) >= 0) {
                                    if (!this.hasExistingItemLevelDiscount(oi, promo)) {
                                        total += oi.quantity;
                                        oi['tmpApplied'] = 0;
                                        if (!(minTotal >= this.count)) {
                                            var q = oi.quantity;
                                            if ((q - oi['tmpApplied']) > 0) {
                                                if (q < this.count) {
                                                    oi['tmpApplied'] += q;
                                                    minTotal += q;
                                                }
                                                else {
                                                    oi['tmpApplied'] += this.count;
                                                    minTotal += this.count;
                                                }
                                            }
                                        }
                                    }
                                }
                                else {
                                    //check for sub item group
                                    for (var _h = 0, _j = oi.groups; _h < _j.length; _h++) {
                                        var ig = _j[_h];
                                        if (codes.indexOf(ig.id) >= 0) {
                                            if (!this.hasExistingItemLevelDiscount(oi, promo)) {
                                                //check all item quantity
                                                for (var _k = 0, _l = ig.items; _k < _l.length; _k++) {
                                                    var item = _l[_k];
                                                    total += item.quantity;
                                                }
                                                if (total >= this.count) {
                                                    ok = true;
                                                    this.applicable = Math.floor(total / this.count);
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    ok = (total >= this.count && minTotal >= this.count);
                                    this.applicable = Math.floor(total / this.count);
                                    if (ok) {
                                        return ok;
                                    }
                                }
                            }
                        }
                    }
                    ok = (total >= this.count && minTotal >= this.count);
                    this.applicable = Math.floor(total / this.count);
                }
                break;
            }
            case 'item_count': {
                this.applicable = 0;
                if (this.code && this.count) {
                    if (this.code.toLowerCase() == "all") {
                        ok = true;
                        order.orderitems.forEach(function (oi) {
                            _this.applicable += oi.quantity;
                        });
                        break;
                    }
                    var codes = this.code.split(",");
                    var total = 0;
                    var minTotal = 0;
                    if (codes && codes.length > 0) {
                        for (var _m = 0, _o = order.orderitems; _m < _o.length; _m++) {
                            var oi = _o[_m];
                            var mainitem = OrderItem.getMainItem(oi); //mainitem
                            if (codes.indexOf(mainitem.id) >= 0) {
                                if (!this.hasExistingItemLevelDiscount(oi, promo)) {
                                    total += oi.quantity;
                                    oi['tmpApplied'] = 0;
                                    if (!(minTotal >= this.count)) {
                                        var q = oi.quantity;
                                        if ((q - oi['tmpApplied']) > 0) {
                                            if (q < this.count) {
                                                oi['tmpApplied'] += q;
                                                minTotal += q;
                                            }
                                            else {
                                                oi['tmpApplied'] += this.count;
                                                minTotal += this.count;
                                            }
                                        }
                                    }
                                }
                            }
                            //TODO: Check subitems
                        }
                    }
                    ok = (total >= this.count && minTotal >= this.count);
                    this.applicable = Math.floor(total / this.count);
                }
                break;
            }
            //ordered mainitems not under specific group
            case 'exitemgroup': {
                var total = 0;
                this.applicable = 0;
                ok = true;
                if (this.code && order.orderitems) {
                    // for (let oi of order.orderitems) {
                    //     if (oi.groups && oi.groups.length > 0){
                    //         let group = oi.groups[0]; //Main itemgroup
                    //         if (this.code !== group.id) total += oi.quantity;
                    //     }
                    // }
                    for (var _p = 0, _q = order.orderitems; _p < _q.length; _p++) {
                        var oi = _q[_p];
                        if (oi.groups && oi.groups.length > 0) {
                            var group = oi.groups[0]; //Main itemgroup
                            if (!this.oiContainsCode(oi)) { //revert
                                ok = false;
                                break;
                            }
                            else {
                                total += oi.quantity;
                            }
                        }
                    }
                }
                if (ok && total > 0) {
                    this.applicable = total;
                }
                break;
            }
            //not order mainitems
            case 'exitem':
                {
                    var total = 0;
                    if (this.code && order.orderitems) {
                        for (var _r = 0, _s = order.orderitems; _r < _s.length; _r++) {
                            var oi = _s[_r];
                            if (oi.items && oi.items.length > 0) {
                                var mainitem = oi.items[0]; //Main item
                                if (this.code !== mainitem.id)
                                    total += oi.quantity;
                            }
                        }
                    }
                    ok = total > 0;
                    this.applicable = total;
                    break;
                }
            //promotion code
            case 'code':
                {
                    this.applicable = 0;
                    if (this.code && order.promoCode && this.promoCodeCheck(order.promoCode, this.code)) {
                        ok = true;
                        this.applicable = 1;
                    }
                    else if (this.code && order.promoCodes && order.promoCodes.length > 0) {
                        for (var _t = 0, _u = order.promoCodes; _t < _u.length; _t++) {
                            var pC = _u[_t];
                            if (this.promoCodeCheck(pC, this.code)) {
                                ok = true;
                                this.applicable = 1;
                                break;
                            }
                        }
                    }
                    break;
                }
            //TODO check when payment -test if card no can be got??????? when check
            case 'cardprefix':
                {
                    if (order.payment && order.payment == "creditcard" && this.prefix) {
                        //TODO
                        var payment = order.payments[0];
                        if (payment.cardNo.indexOf(this.prefix) === 0) {
                            ok = true;
                        }
                    }
                    break;
                }
            //TODO
            case "offer":
                {
                    var offer = order.offers.find(function (offer) {
                        return (offer.backendId === _this.code) || (offer.campaignId === parseInt(_this.code));
                    });
                    if (offer)
                        ok = true;
                    break;
                }
            //TODO
            case "reward":
                {
                    this.applicable = 0;
                    var offer = order.offers.find(function (offer) {
                        return (offer.rewardId === parseInt(_this.code));
                    });
                    if (offer) {
                        this.applicable = 1;
                        ok = true;
                    }
                    break;
                }
            //TODO
            case "welcome":
                {
                    if (order.member) {
                        //TODO get welcomed???
                        // if (order.member.membership)
                    }
                    break;
                }
            //TODO?? byod?? code = dinein / takeaway / delivery / byod
            case "ordertype":
                {
                    if (this.code) {
                        var codes = this.code.split(",");
                        if (codes && codes.length > 0) {
                            if (codes.indexOf("dinein") >= 0 && !order.takeout) {
                                ok = true;
                            }
                            else if (codes.indexOf("takeaway") >= 0 && order.takeout) {
                                ok = true;
                            }
                            else if (codes.indexOf("delivery") >= 0 && order.type === "delivery") {
                                ok = true;
                            }
                            else if (codes.indexOf("byod") >= 0 && order.type === "byod") {
                                ok = true;
                            }
                        }
                        else {
                            ok = true;
                        }
                    }
                    break;
                }
            case "seats":
                {
                    if (order.seats && order.seats > this.amount) {
                        ok = this.applicable > 0;
                    }
                    break;
                }
            case "source":
                {
                    if (this.source.indexOf(order.source) > -1)
                        ok = true;
                    break;
                }
            case "points":
                {
                    if (order.usedPoints == this.couponPoint)
                        ok = true;
                    break;
                }
            default:
                break;
        }
        console.log("isSatisfied: ", ok);
        return ok;
    };
    /**Decide discount's level, item or order level**/
    Condition.prototype.getLevel = function () {
        if (this.level)
            return this.level;
        switch (this.type) {
            case 'item':
            case 'itemgroup':
            case 'exitemgroup':
            case 'exitem':
            case "itemgroup_count":
            case "item_count": {
                this.level = "item";
                break;
            }
            case 'all':
            case 'ordertype':
            case 'coupon':
            case 'guest':
            case 'member':
            case 'total':
            case 'code':
            case 'seats':
            case 'points':
            case 'source':
            case 'reward':
            case 'mainitem_count':
            case 'cardprefix': {
                this.level = "order";
                break;
            }
            default: {
                this.level = "";
                break;
            }
        }
        return this.level;
    };
    Condition.prototype.getDisplay = function () {
        if (this.display)
            return this.display;
        switch (this.type) {
            case 'guest': {
                this.display = "Guest";
                break;
            }
            case 'member': {
                this.display = "Member";
                break;
            }
            case 'all':
            case 'coupon':
            case 'total':
            case 'itemgroup':
            case 'item':
            case 'code':
            case 'cardprefix':
            case 'exitemgroup':
            case 'source':
            case 'ordertype':
            default: {
                this.display = "";
                break;
            }
        }
        return this.display;
    };
    /**For item level discount,
     * check if order items have specific items/itemgroups with id == code
     * **/
    Condition.prototype.oiContainsCode = function (oi) {
        if (!this.code)
            return false;
        if (this.code.toLowerCase() == "all")
            return true;
        var contain = false;
        switch (this.type) {
            case "item": {
                var codes = this.code.split(",");
                if (codes && codes.length > 0) {
                    var item = oi.items[0]; //Main Item
                    if (codes.indexOf(item.id) >= 0) {
                        contain = true;
                    }
                }
                break;
            }
            case "itemgroup": {
                var codes = this.code.split(",");
                if (codes && codes.length > 0) {
                    //let item = oi.items[0]; //Main Item
                    if (codes.indexOf(oi.groups[0].id) >= 0) {
                        contain = true;
                    }
                }
                break;
            }
            case "itemgroup_count": {
                var codes = this.code.split(",");
                if (oi.groups && oi.groups.length > 0) {
                    var group = oi.groups[0]; //Main itemgroup
                    if (codes && codes.length > 0) {
                        if (codes.indexOf(group.id) >= 0) {
                            contain = true;
                        }
                        else {
                            //check for sub item group
                            for (var _i = 0, _a = oi.groups; _i < _a.length; _i++) {
                                var ig = _a[_i];
                                if (codes.indexOf(group.id) >= 0) {
                                    contain = true;
                                    break;
                                }
                            }
                        }
                    }
                }
                break;
            }
            case "item_count": {
                var codes = this.code.split(",");
                var mainitem = OrderItem.getMainItem(oi); //mainitem
                if (codes && codes.length > 0) {
                    if (codes.indexOf(mainitem.id) >= 0) {
                        contain = true;
                    }
                    else {
                        //TODO: check subitem
                    }
                }
                break;
            }
            case "exitemgroup": {
                var codes = this.code.split(",");
                if (codes && codes.length > 0) {
                    //let item = oi.items[0]; //Main Item
                    if (codes.indexOf(oi.groups[0].id) < 0) {
                        contain = true;
                    }
                }
                break;
            }
            case "exitem": {
                if (oi.items && oi.items.length > 0 && (oi.items[0].id !== this.code)) {
                    contain = true;
                }
                break;
            }
            default:
                break;
        }
        return contain;
    };
    Condition.prototype.setCode = function (code) {
        this.code = code;
    };
    Condition.prototype.setDisplay = function (display) {
        this.display = display;
    };
    //TODO??
    Condition.prototype.isMainItemOnly = function () {
        if (this.type === 'total')
            return true;
        if (this.type == 'itemgroup' || this.type == 'itemgroup_count' || this.type == 'item_count')
            return !this.traverseItemsDiscountable;
        return false;
    };
    Condition.prototype.toProperty = function (name, value) {
        return value;
    };
    Condition.prototype.hasExistingItemLevelDiscount = function (oi, promo) {
        var occupied = false;
        // if already applied an item level discount, do not apply another item level discount
        if (this.getLevel() === 'item') {
            if (oi.discounts && oi.discounts.length > 0) {
                occupied = oi.discounts.some(function (discount) {
                    return discount.id === promo.id || discount.level === 'item';
                });
                console.log('occupied: ' + promo.name, occupied);
            }
        }
        return occupied;
    };
    Condition.prototype.promoCodeCheck = function (promoteCode, code) {
        if (this.ignoreCase) {
            return promoteCode.toLowerCase() === code.toLowerCase();
        }
        return promoteCode === code;
    };
    return Condition;
}(Data));
export { Condition };
//# sourceMappingURL=condition.js.map